<ion-list mode="ios" lines="none" class="list-content info-sheet-modal-content">
  <!-- ! Header -->
  <ion-item mode="md" lines="none" color="getm-neutral-white">
    <ion-label color="getm-neutral-dark" class="promotion-summary">
      {{ 'Labels.' + (promo.Bonificacion ? 'bonus-summary' :
      'promotion-summary') | translate }}
    </ion-label>

    <ion-button
      shape="round"
      mode="ios"
      slot="end"
      class="button-close"
      color="getm-neutral-selected"
      (click)="onClose()"
    >
      <ion-icon
        slot="icon-only"
        name="close-outline"
        color="getm-neutral-dark"
      ></ion-icon>
    </ion-button>
  </ion-item>

  <!-- * subtitle -->
  <ion-item
    mode="md"
    lines="none"
    color="getm-neutral-white"
    class="item-products-selected-and-savings"
  >
    <ion-label color="getm-neutral-dark" class="products-selected-and-savings">
      {{ 'Labels.products-selected-and-savings' | translate }}
    </ion-label>
  </ion-item>

  <!-- ! Resumen de productos -->
  <ion-card mode="ios" color="getm-neutral-white" class="card-products">
    <ion-card-header mode="ios" color="getm-neutral-white" class="card-header">
      <ion-label color="getm-neutral-dark" class="total-promotions">
        {{ 'Labels.' + (promo.Bonificacion ? 'total-bonuses' :
        'total-promotions') | translate }}
        <ion-text class="ion-float-end"> {{ quantity }} </ion-text>
      </ion-label>
    </ion-card-header>

    <ion-item
      mode="md"
      color="transparent"
      lines="none"
      class="item-list-products"
    >
      <ion-label>
        <ng-container *ngFor="let product of productosPromocion">
          <ng-container *ngIf="product.productos > 0">
            <p class="list-products">
              {{ quantity * product.productos }} {{ product.title }}
            </p>
          </ng-container>
        </ng-container>
      </ion-label>
    </ion-item>

    <!-- * Totales -->
    <ion-item mode="md" color="transparent" lines="none">
      <ion-label>
        <p class="prices">
          {{ 'Labels.total-no-discount' | translate }}
          <ion-text
            color="getm-neutral-gray"
            class="total_precio ion-float-right"
          >
            <del>
              {{ (productosPromocion | summaryPrice : quantity).total_precio |
              currency : undefined : 'symbol' : '1.2-2' }}
            </del>
          </ion-text>
        </p>
        <p class="prices">
          {{ 'Labels.discount' | translate }}
          <ion-text
            color="getm-secondary-default"
            class="total_descuento ion-float-right"
          >
            <ion-icon
              class="icon-discount"
              name="getm-discount-outline"
              color="getm-secondary-default"
            ></ion-icon>
            {{ (productosPromocion | summaryPrice : quantity).total_descuento |
            currency : undefined : 'symbol' : '1.2-2' }}
          </ion-text>
        </p>
        <p class="prices">
          {{ 'Labels.total-to-pay' | translate }}
          <ion-text
            color="getm-neutral-dark"
            class="total_precio_descuento ion-float-right"
          >
            {{ (productosPromocion | summaryPrice :
            quantity).total_precio_descuento | currency : undefined : 'symbol' :
            '1.2-2' }}
          </ion-text>
        </p>
      </ion-label>
    </ion-item>
  </ion-card>

  <!-- ! Agregar promos -->
  <ng-container
    *ngIf="!isResume && promo.MaximoPaquetes > 1 && promo.TipoPromocion !== 'ESCALERA'"
  >
    <getm-add-another-promo-row
      [selected]="quantity"
      [minimum]="1"
      [maximum]="promo.MaximoPaquetes"
      (selectedAddPromo)="selectedAddPromo($event)"
    ></getm-add-another-promo-row>
  </ng-container>

  <!-- ! Actions -->
  <ion-row class="ion-justify-content-between content-actions">
    <ng-container *ngIf="!isResume">
      <ion-col size="5.8" class="ion-no-padding">
        <getm-button
          [text]="'Buttons.edit' | translate"
          color="tertiary"
          size="large"
          icon="getm-edit-outline"
          iconSlot="end"
          expand="block"
          (btnClick)="onEdit()"
        ></getm-button>
      </ion-col>

      <ion-col size="5.8" class="ion-no-padding">
        <getm-button
          [text]="'Buttons.confirm' | translate"
          color="primary"
          size="large"
          expand="block"
          (btnClick)="onConfirm()"
        ></getm-button>
      </ion-col>
    </ng-container>

    <ng-container *ngIf="isResume">
      <ion-col size="12" class="ion-no-padding">
        <getm-button
          [text]="'Buttons.enderstood' | translate"
          color="tertiary"
          size="default"
          expand="block"
          (btnClick)="onClose()"
        ></getm-button>
      </ion-col>
    </ng-container>
  </ion-row>
</ion-list>
